import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../utils/styles';

const StyledBudgetsRequestPageContainer = styled.div`
  padding: 24px;
`;

const StyledBudgetsRequestPageContent = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};

  border-radius: 4px;
  padding: 24px;
  width: 100%;

  .amount {
    color: ${props => props.theme.colors.neutral_10};
  }
`;

export {
  StyledBudgetsRequestPageContainer,
  StyledBudgetsRequestPageContent,
}
